






























































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  Company,
  domain,
  Payment,
  DBBranchData,
  PaymentStatus,
  ListPaymentQuery,
  VueRoot,
  PaymentList
} from "@/domain";
import QuickSnack from "@/components/QuickSnack.vue";
import DatePicker from "@/components/DatePicker.vue";
import * as util from "@/util";
import * as excel from "@/util/excel";
import { applyFilter, DataType } from "@/modules/filters";
import * as uiUtil from "@/uiUtil";
import { printCents } from "@/util/format";

interface Field {
  text: string;
  value: string;
  filter?: string;
  sortable?: boolean;
  align?: "left" | "right" | "center";
  cssClass?: string;
}
interface Filters extends ListPaymentQuery {
  company: Company;
  branch: BranchItem;
  after?: string;
  hasMore: boolean;
}

@Component({
  components: { QuickSnack, DatePicker }
})
export default class PaymentListView extends Vue {
  error = "";
  isLoading = false;
  isLoadingMore = false;
  loadingFile = "";
  itemSearch = "";
  itemActionLoading = "";

  goToDialog = false;
  txtSearchID = "";

  // Data after query
  branches: BranchItem[] = [];
  branchesLoading = false;
  payments: PaymentItem[] = [];
  lastResult: PaymentList | null = null;
  lastFilters: Filters | null = null;

  // Filters
  filterDialog = false;
  txtFromDate = util.isoDateString(-30 * 7);
  txtToDate = util.isoDateString(1);
  selBranch: BranchItem | null = null;
  selectedStatus: PaymentStatus | "" = "";

  pagination = {
    sortBy: "createdOn",
    descending: true,
    rowsPerPage: -1
  };

  fields: Field[] = [
    {
      text: this.lang.operation,
      value: "fullID"
    },
    {
      text: this.lang.creation,
      value: "createdOn",
      filter: "date",
      sortable: true
    },
    {
      text: this.lang.expiration,
      value: "expirationUTC",
      filter: "utcToLocal"
    },
    {
      text: this.lang.email,
      value: "userEmail"
    },
    {
      text: this.lang.amount,
      align: "right",
      value: "fullAmount"
    },
    {
      text: this.lang.state,
      value: "status",
      cssClass: "statusCss"
    },
    {
      text: this.lang.visible,
      value: "isVisible",
      filter: "boolSiNo"
    }
  ];

  get lang() {
    return this.$store.state.lang.data;
  }

  get headers() {
    const headers = this.fields.map((f) => ({
      text: f.text,
      value: f.value,
      align: f.align,
      sortable: !!f.sortable
    }));
    headers.push({
      text: "Actions",
      value: "",
      align: "left",
      sortable: false
    });
    return headers;
  }

  get snack(): QuickSnack {
    return this.$refs.snack as QuickSnack;
  }

  cellCSSClass(field: Field, item: PaymentItem): string {
    let result = "text-no-wrap text-xs-" + (field.align ? field.align : "left");
    if (field.cssClass) {
      result += " " + item[field.cssClass];
    }
    return result;
  }

  get currentCompanyLoading(): boolean {
    return this.$store.state.selectedCompanyLoading || this.branchesLoading;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get currentBranches(): BranchItem[] {
    if (this.currentCompany) {
      return uiUtil.branchAddAllItem(this.branches, this.$store.getters.userPermission, {
        id: -1,
        name: this.lang.allOffices
      });
    }
    return [];
  }
  isOnExpiryCharge(item: PaymentItem) {
    if (item.onExpiryCharge?.attempts && item.onExpiryCharge.attempts > 0) return true;
    else return false;
  }

  @Watch("currentCompany")
  onCompanyChanged(newCompany?: Company, oldCompany?: Company) {
    if (!newCompany || (oldCompany && newCompany.id === oldCompany.id)) {
      return;
    }
    util.promiseEnd(this.refreshBranchesAndFilterList());
  }

  created() {
    util.promiseEnd(this.refreshBranchesAndFilterList());
  }

  async refreshBranchesAndFilterList() {
    await this.refreshBranches();
    await this.filterList(false);
  }

  async refreshBranches() {
    this.branchesLoading = true;
    if (this.currentCompany) {
      const branches = await domain.backend.paymentGetBranches(this.currentCompany.id);
      this.branches = (branches || []).map((b) => ({
        id: b.branchID,
        name: b.displayName || b.name,
        original: b
      }));
    } else {
      this.branches = [];
    }
    if (this.currentBranches.length === 0) {
      this.selBranch = null;
    } else {
      this.selBranch = this.currentBranches[0];
    }
    this.branchesLoading = false;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get isValid(): boolean {
    return !!this.selBranch && !!this.currentCompany && !!this.txtFromDate && !!this.txtToDate;
  }

  get isLoadingAny() {
    return this.isLoading || this.branchesLoading;
  }

  onSortChanged() {
    if (this.lastFilters) {
      if (
        this.pagination.sortBy !== this.lastFilters.sortField &&
        !!this.pagination.descending !== (this.lastFilters.sortDir === "desc")
      ) {
        this.$nextTick(() => {
          util.promiseEnd(this.filterList(false));
        });
      }
    }
  }

  cmdLoadMore() {
    util.promiseEnd(this.filterList(true));
  }

  cmdConsultar() {
    util.promiseEnd(this.filterList(false));
  }

  cmdGoToPayment() {
    if (!util.isEmpty(this.txtSearchID)) {
      this.goToEdit(this.txtSearchID);
    }
  }

  async filterList(addAfter: boolean) {
    if (!this.isValid) {
      this.error = this.lang.errorSelectParamsToQuery;
      return false;
    }
    if (!addAfter) {
      this.itemSearch = "";
    }
    this.isLoadingMore = addAfter;
    this.isLoading = true;
    this.error = "";
    try {
      const LIMIT = 20;
      if (!this.currentCompany || !this.selBranch) return;
      const filters: ListPaymentQuery = {
        companyID: this.currentCompany.id,
        branchID: this.selBranch.id === -1 ? undefined : this.selBranch.id,
        from: this.txtFromDate,
        to: this.txtToDate,
        limit: LIMIT,
        sortField: this.pagination.sortBy,
        sortDir: this.pagination.descending ? "desc" : "asc",
        status: this.selectedStatus,
        after: addAfter ? this.lastFilters?.after : undefined
      };
      const result = await domain.backend.listPayments(filters);
      const newPayments = result.payments.map(this.mapPayment);
      if (addAfter) {
        this.payments = [...this.payments, ...newPayments];
      } else {
        this.payments = newPayments;
      }
      this.lastResult = result;
      this.lastFilters = {
        company: this.currentCompany,
        branch: this.selBranch,
        ...filters,
        after: newPayments.length > 0 ? newPayments[newPayments.length - 1].id : undefined,
        hasMore: newPayments.length === LIMIT
      };
      this.filterDialog = false;
    } catch (err) {
      util.logError("Error filtering transactions", err);
      this.payments = [];
      this.lastResult = null;
      this.error = this.lang.errorFilteringResultsRetry;
    }
    this.isLoading = false;
    return this.lastResult !== null;
  }

  mapPayment(p: Payment): PaymentItem {
    let stName: PaymentStatus = "pending";
    const result = {
      ...p,
      userEmail: p.user.email,
      statusID: "",
      status: "",
      statusCss: "",
      fullAmount: printCents(p.amountCents) + " " + p.currency,
      fullID: p.id + " / " + p.clientID
    };
    if (p.lastResult && p.lastResult.isApproved) {
      stName = "approved";
    } else if (p.isCanceled) {
      stName = "canceled";
    } else if (p.isExpired) {
      stName = "expired";
    }
    const st = this.getStatus(stName);
    result.statusID = stName;
    result.status = st.text;
    result.statusCss = st.css;
    return result;
  }

  getStatus(key: PaymentStatus) {
    return (
      this.statusOptions.find((s) => s.key === key) || {
        text: `Desconocido (${key})`,
        css: "grey--text",
        key
      }
    );
  }

  get enabledStatusOptions() {
    return this.statusOptions.filter((st) => st.key !== "expired");
  }

  get statusOptions(): PayStatusItem[] {
    return [
      {
        text: this.lang.all,
        css: "primary--text",
        key: ""
      },
      {
        text: this.lang.pending,
        css: "warning--text",
        key: "pending"
      },
      {
        text: this.lang.aprove,
        css: "success--text",
        key: "approved"
      },
      {
        text: this.lang.cancelled,
        css: "error--text",
        key: "canceled"
      },
      {
        text: this.lang.expired,
        css: "grey--text",
        key: "expired"
      }
    ];
  }

  async cmdExportExcel() {
    if (this.lastFilters && this.payments && this.currentCompany && this.selBranch) {
      this.loadingFile = "excel";
      const headers = this.fields.map((f) => excel.header(f.text, f.value, 20));
      const data = this.payments.map((pay) => {
        const res: { [key: string]: DataType } = {};
        for (const f of this.fields) {
          res[f.value] = applyFilter(pay[f.value] as DataType, f.filter || "");
        }
        return res;
      });
      const filename = util.cleanFilename(
        `${this.lang.filenameName1} ${this.currentCompany.name} - ${this.selBranch.name} ${
          this.lang.filenameName2
        } ${util.displayISODate(this.txtFromDate)} ${this.lang.filenameName3} ${util.displayISODate(this.txtToDate)}`
      );
      try {
        await excel.writeSpreadsheet(filename, this.lang.paymentRequet, headers, data);
      } catch (err) {
        util.logError("Error escribiendo excel", err);
        this.snack.show(this.lang.errorGeneratingFile, "error");
      }
      this.loadingFile = "";
    }
  }

  lstEditItem(item: PaymentItem) {
    this.goToEdit(item.id);
  }

  async lstEmailItem(item: PaymentItem) {
    try {
      this.itemActionLoading = item.id;
      const result = await domain.backend.paymentAction({
        key: item.id,
        action: "send_email"
      });
      if (result.success) {
        this.snack.show(this.lang.alertSuccessEmail, "success");
      } else {
        this.snack.show("Error enviando email", "error");
      }
    } catch (ex) {
      util.logError("Error enviando email", ex);
      this.snack.show(this.lang.errorSendingEmail, "error");
    }
    this.itemActionLoading = "";
  }

  goToEdit(paymentID: string) {
    uiUtil.routePush(this, { path: "/paymentEdit", query: { id: paymentID } });
  }

  lstPaymentURL(item: PaymentItem): string {
    return domain.backend.makePaymentURL(item.id);
  }
}

interface PayStatusItem {
  text: string;
  css: string;
  key: PaymentStatus | "";
}

interface BranchItem {
  id: number;
  name: string;
  original?: DBBranchData;
}

interface PaymentItem extends Payment {
  userEmail: string;
  statusID: string;
  status: string;
  statusCss: string;
  fullAmount: string;
  fullID: string;
  [key: string]: unknown;
}
